import {ModuleWithProviders} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';

//Importar componentes
import { PrincipalComponent } from './components/principal/principal.component';
import { OrdenproduccionComponent } from './components/ordenproduccion/ordenproduccion.component';
import { IngresoproduccionComponent } from './components/ingresoproduccion/ingresoproduccion.component';
import { ControlproduccionComponent } from './components/controlproduccion/controlproduccion.component';
import { LotesComponent } from './components/lotes/lotes.component';
import { EmpaquesComponent } from './components/empaques/empaques.component';
import { BloqueosComponent } from './components/bloqueos/bloqueos.component';
import { PackinglistComponent } from './components/packinglist/packinglist.component';
import { VencimientosComponent } from './components/vencimientos/vencimientos.component';
import { ProductosComponent } from './components/productos/productos.component';
import { StockComponent } from './components/stock/stock.component';
import { CapacidadComponent } from './components/capacidad/capacidad.component';
import { PalletsComponent } from './components/pallets/pallets.component';
import { InventariosComponent } from './components/inventarios/inventarios.component';
import { MovimientosComponent } from './components/movimientos/movimientos.component';
import { FichasComponent } from './components/fichas/fichas.component';
import { TratosComponent } from './components/tratos/tratos.component';
import { EstadisticaComponent } from './components/estadistica/estadistica.component';
import { ClientesComponent } from './components/clientes/clientes.component';
import { ProveedoresComponent } from './components/proveedores/proveedores.component';
import { DespachosComponent } from './components/despachos/despachos.component';
import { ReportesComponent } from './components/reportes/reportes.component';
import { PerfilComponent } from './components/perfil/perfil.component';
import { SalirComponent } from './components/salir/salir.component';
import { PermisosComponent } from './components/permisos/permisos.component';
import { PanelcontrolComponent } from './components/panelcontrol/panelcontrol.component';
import { SignupComponent } from './auth/signup/signup.component';
import { SigninComponent } from './auth/signin/signin.component';
import { EspecificacionComponent } from './components/especificacion/especificacion.component';
import { TagsComponent } from './components/tags/tags.component';
import { PackingEcComponent } from './components/packing-ec/packing-ec.component';
import { SalidasComponent } from './components/salidas/salidas.component';
import { EntradasComponent } from './components/entradas/entradas.component';
import { DesconcheComponent } from './components/desconche/desconche.component';
import { UnionsaldoComponent } from './components/unionsaldo/unionsaldo.component';
import { ReimprimiretiquetaComponent } from './components/reimprimiretiqueta/reimprimiretiqueta.component';
import { ReimprimirpalletComponent } from './components/reimprimirpallet/reimprimirpallet.component';
import { DevolucionComponent } from './components/devolucion/devolucion.component';
import { SolicitudmovimientoComponent } from './components/solicitudmovimiento/solicitudmovimiento.component';
import { EditComponent } from './components/solicitudmovimiento/edit/edit.component';
import { DetailComponent } from './components/solicitudmovimiento/detail/detail.component';
import { OrdenespendientesComponent } from './components/ordenespendientes/ordenespendientes.component';
import { RevisionorderComponent } from './components/revisionorder/revisionorder.component';
import { StocknodisponibleComponent } from './components/stocknodisponible/stocknodisponible.component';
import { StockcomercialComponent } from './components/stockcomercial/stockcomercial.component';
import {RendimientoComponent} from './components/rendimiento/rendimiento.component';
import {ReingresocajasComponent} from './components/reingresocajas/reingresocajas.component';



import { AuthGuard } from './security/auth.guard';

const appRoutes:Routes =[
  {path:'',component:PanelcontrolComponent},
  {path:'orden',component:OrdenproduccionComponent, canActivate:[AuthGuard]},
  {path:'ingreso',component:IngresoproduccionComponent, canActivate:[AuthGuard] },
  {path:'aduana',component:ControlproduccionComponent, canActivate:[AuthGuard]},
  {path:'lotes',component:LotesComponent, canActivate:[AuthGuard]},
  {path:'empaque',component:EmpaquesComponent, canActivate:[AuthGuard]},
  {path:'bloqueos',component:BloqueosComponent, canActivate:[AuthGuard]},
  {path:'packinglist',component:PackinglistComponent, canActivate:[AuthGuard]},
  {path:'vencimientos',component:VencimientosComponent, canActivate:[AuthGuard]},
  {path:'productos',component:ProductosComponent, canActivate:[AuthGuard]},
  {path:'stock',component:StockComponent, canActivate:[AuthGuard]},
  {path:'stockreal', component:StocknodisponibleComponent, canActivate:[AuthGuard]},
  {path:'stockcomercial', component:StockcomercialComponent, canActivate:[AuthGuard]},
  {path:'capacidad',component:CapacidadComponent, canActivate:[AuthGuard]},
  {path:'pallets',component:PalletsComponent, canActivate:[AuthGuard]},
  /*{path:'inventarios',component:InventariosComponent, canActivate:[AuthGuard]},*/
  {path:'movimientos',component:MovimientosComponent, canActivate:[AuthGuard]},
  {path:'fichas',component:FichasComponent, canActivate:[AuthGuard]},
  {path:'tratos',component:TratosComponent, canActivate:[AuthGuard]},
  {path:'estadistica',component:EstadisticaComponent, canActivate:[AuthGuard]},
  {path:'clientes',component:ClientesComponent, canActivate:[AuthGuard]},
  {path:'proveedores',component:ProveedoresComponent, canActivate:[AuthGuard]},
  {path:'despachos',component:DespachosComponent, canActivate:[AuthGuard]},
  {path:'reportes',component:ReportesComponent, canActivate:[AuthGuard]},
  {path:'salir',component:SalirComponent, canActivate:[AuthGuard]},
  {path:'perfil',component:PerfilComponent, canActivate:[AuthGuard]},
  {path:'permisos',component:PermisosComponent, canActivate:[AuthGuard]},
  {path:'panelcontrol',component:PanelcontrolComponent, canActivate:[AuthGuard]},
  {path:'signup',component:SignupComponent, canActivate:[AuthGuard]},
  {path:'login',component:SigninComponent},
  {path:'especificaciones',component:EspecificacionComponent, canActivate:[AuthGuard]},
  {path:'etiquetas',component:TagsComponent, canActivate:[AuthGuard]},
  {path:'packingentrada',component:PackingEcComponent, canActivate:[AuthGuard]},
  {path:'stocksalidas',component:SalidasComponent, canActivate:[AuthGuard]},
  {path:'stockentradas',component:EntradasComponent, canActivate:[AuthGuard]},
  {path:'desconche',component:DesconcheComponent, canActivate:[AuthGuard]},
  {path:'unionsaldo',component:UnionsaldoComponent, canActivate:[AuthGuard]},
  /*{path: 'reimprimir', component: ReimprimiretiquetaComponent, canActivate:[AuthGuard]},*/
  {path: 'reimprimirpallet', component: ReimprimirpalletComponent, canActivate:[AuthGuard]},
  {path: 'devolucion', component: DevolucionComponent, canActivate:[AuthGuard]},
  {path: 'solicitud', component: SolicitudmovimientoComponent, canActivate:[AuthGuard]},
  {path: 'solicitud/editar/:id', component: EditComponent, canActivate:[AuthGuard]},
  {path: 'solicitud/detalle/:id', component: DetailComponent, canActivate:[AuthGuard]},
  {path: 'solicitudenrevision', component: RevisionorderComponent, canActivate:[AuthGuard]},

  {path: 'solicitudesaprobadas', component: OrdenespendientesComponent, canActivate:[AuthGuard]},
  {path: 'rendimiento', component: RendimientoComponent, canActivate:[AuthGuard]},
  {path: 'reingreso_cajas', component: ReingresocajasComponent, canActivate:[AuthGuard]},
  {path:'**',component:PanelcontrolComponent}
];

export const appRoutingProviders: any[] = [];
/*use hash true para que siempre use como base la carpeta del proyecto*/
export const routing:ModuleWithProviders = RouterModule.forRoot(appRoutes,{useHash:true});



// WEBPACK FOOTER //
// C:/Apache24/htdocs/ostimar/frontend/src/app/app.routing.ts